<!-- 需方部门管理总页面 -->
<template>
  <div id="appid" class="app-container">
    <div class="top-search">
      <header class="search-title">
        <span class="title-text">部门管理</span>
      </header>
    </div>
    <!--左侧条件-->
    <div class="bigBox">
      <div class="left-condition">
        <div class="condition-conton">
          <div class="con-header">
            <div class="search-top">
              <span class="branch" />
              <span class="query">查询</span>
            </div>
            <div class="right">《</div>
          </div>
          <div class="con-con">
            <div class="condition">
              <el-input v-model="filterText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="tree"
                node-key="FID"
                class="filter-tree"
                :data="datasele"
                :props="defaultProps"
                default-expand-all
                :filter-node-method="filterNode"
                :expand-on-click-node="false"
                :highlight-current="true"
                @node-click="handleTreeNodeClick"
              />
            </div>
          </div>
        </div>
      </div>
      <!--右侧表格-->
      <div class="right-table">
        <div class="right-operation">
          <div class="search-form">
            是否删除：
            <el-select v-model="pageLIst.FDeleteFlag" placeholder="请选择">
              <el-option
                label="全部"
                value="-1"
              />
              <el-option
                label="未删除"
                value="0"
              />
              <el-option
                label="已删除"
                value="1"
              />
            </el-select>
          </div>
          <el-button style="margin-left:30px;" class="right-btn" @click="getInitData">
            查询
          </el-button>
          <el-button v-if="rols('新增')" style="float: right;" class="right-btn" @click="addDepartment">
            <i class="el-icon-circle-plus-outline">
              新增
            </i>
          </el-button>
        </div>
        <div class="right-operation">
          <el-button v-if="rols('删除')" class="left-btn" @click="batchOperation(false)">
            <i class="el-icon-delete">
              批量删除
            </i>
          </el-button>
          <el-button v-if="rols('确认')" class="left-btn" @click="batchOperation(true)">
            <i class="el-icon-check">
              批量确认
            </i>
          </el-button>
        </div>
        <div class="bottom-table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            fit
            :header-cell-style="{
              background: '#F3F3F3',
              color: '#202020',
              fontSize: '14px',
            }"
            :cell-style="{ fontSize: '16px'}"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50" align="center" />
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="FDemandUnitName" show-overflow-tooltip label="所属公司" />
            <el-table-column prop="FName" show-overflow-tooltip label="节点名称" />
            <el-table-column prop="FLevelName" show-overflow-tooltip label="层级" />
            <el-table-column
              prop="FAccepter"
              label="确认人"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FAcceptDate"
              label="确认日期"
              show-overflow-tooltip
            />
            <el-table-column label="操作" width="200" align="right">
              <template slot-scope="scope">
                <div class="bottom-operation">
                  <span v-if="rols('确认')" @click="addOperation(2,scope.row)">
                    确认
                  </span>
                  <span v-if="rols('修改')" @click="editDepartment(scope.row)">
                    修改
                  </span>
                  <span v-if="rols('删除')" @click="addOperation(0,scope.row)">
                    删除
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <smallTips :tips-visible="tipsVisible" :tips-data="tipsData" :tips-type="tipsType" @tipsSwitch="tipsSwitch" />
    <addDepart :title="title" :select-tree="selectTree" :add-visible="addVisible" @addSwitch="addSwitch" />

  </div>
</template>

<script>
import service from '@/utils/request'
import smallTips from '@/components/small-tips'
import addDepart from './addDepart.vue'
import { queryDemanddepart, queryDemanddepartChildren } from '@/api/department.js'
export default {
  components: {
    smallTips,
    addDepart
  },
  data() {
    return {
      title: '新增部门',
      addVisible: false,
      tipsArr: [
        {
          title: '删除',
          svgClass: 'depart-delete',
          text: '确认删除该部门吗？'
        },
        {
          title: '无法删除',
          svgClass: 'depart-nodelete',
          text: '该部门已确认，无法删除！'
        },
        {
          title: '确认有效',
          svgClass: 'depart-valid',
          text: '确认有效该部门吗？'
        },
        {
          title: '确认',
          svgClass: 'depart-confirm',
          text: '该部门已确认！'
        }
      ],
      tipsData: {
        title: '',
        svgClass: '',
        text: ''
      },
      tipsType: null,
      tipsVisible: false,
      checked: false,
      filterText: '',
      datasele: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pageLIst: {
        FID: null,
        FDeleteFlag: '0',
        pageNo: 1,
        pageSize: 10
      },
      tableData: [],
      multipleSelection: [],
      centerDialogVisibleConfirm: false,
      treeData: [],
      dataStr: '',
      selectTree: {
        FID: '',
        FLevelName: '',
        FDemandUnitName: '',
        FName: ''
      },
      selectTreeId: null
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('部门管理')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
  },
  created() {
    this.getTree()
  },
  methods: {
    batchOperation(b) {
      if (this.multipleSelection.length) {
        const arr = []
        this.multipleSelection.forEach(item => {
          arr.push(item.FID)
        })
        const str = arr.toString()
        b ? this.acceptAndDelete(true, str) : this.acceptAndDelete(false, str)
      }
    },
    acceptAndDelete(b, ids) {
      const url = b ? '/mall/mallmanage/demanddepart/acceptDemanddepart' : '/mall/mallmanage/demanddepart/deleteDemanddepart'
      const loadingObj = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.submit-test-dialog')
      })
      const params = new URLSearchParams()
      params.append('jsonStr', JSON.stringify({ FIDs: ids }))
      service({
        url,
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.getTree()
            this.getInitData()
            this.tipsVisible = false
          } else {
            this.$message.error(res.msg)
          }
          loadingObj.close()
        })
        .catch(() => {
          loadingObj.close()
        })
      this.tipsType = null
    },
    editDepartment(row) {
      this.selectTree = row
      this.title = '修改部门'
      this.addVisible = true
    },
    addOperation(n, row) {
      this.tipsType = row.FAccepted ? n + 1 : n
      this.selectRow = row
      this.tipsData = row.FAccepted ? this.tipsArr[n + 1] : this.tipsArr[n]
      if (n === 0) {
        this.tipsType = n
        this.tipsData = this.tipsArr[n]
      }
      this.tipsVisible = true
    },
    addDepartment() {
      this.title = '新增部门'
      if (this.selectTree.FID) {
        if (!this.selectTree.FTreeCode) {
          return this.$message.warning('请先确认当前部门!')
        }
        if (this.selectTree.FTreeCode.length < 9) {
          this.addVisible = true
        } else {
          this.$message.warning('最大支持五级部门设置')
        }
      } else {
        this.$message.warning('请先选中所属部门')
      }
    },
    addSwitch(val) {
      this.addVisible = false
      if (val) {
        this.getTree()
        this.getInitData()
      }
    },
    tipsSwitch(b, val) {
      if (b) {
        if (val === 2) {
          this.acceptAndDelete(true, this.selectRow.FID)
        } else if (val === 0) {
          this.acceptAndDelete(false, this.selectRow.FID)
        } else {
          this.tipsVisible = false
        }
      } else {
        this.tipsVisible = false
      }
      this.tipsType = null
    },
    handleTreeNodeClick(data, node, elem) {
      this.selectTreeId = data.FID
      this.selectTree = {
        FID: data.FID,
        FDemandUnitName: data.FDemandUnitName,
        FLevelName: data.FLevelName,
        FTreeCode: data.FTreeCode
      }
      this.pageLIst.FID = data.FID
      this.currentPage = 1
      this.getInitData(data.fid)
    },
    // 查询表格数据
    getInitData() {
      if (!this.pageLIst.FID) {
        return
      }
      this.loading = true
      queryDemanddepartChildren({
        FID: this.pageLIst.FID,
        FDeleteFlag: Number(this.pageLIst.FDeleteFlag),
        pageNo: this.currentPage,
        pageSize: this.pageSize
      })
        .then((res) => {
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取树形控件数据
    getTree() {
      const params = new URLSearchParams()
      params.append('name', this.filterText)
      params.append('pageNo', 1)
      params.append('pageSize', -1)
      queryDemanddepart(params)
        .then((res) => {
          this.toTree(res.data.records)
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.selectTreeId)
          })
        })
    },
    toTree(data) {
      const obj = {} // 使用对象重新存储数据
      const res = [] // 存储最后结果
      const len = data.length
      // 遍历原始数据data，构造obj数据，键名为id，值为数据
      for (let i = 0; i < len; i++) {
        data[i].label = data[i].FName
        obj[data[i]['FID']] = data[i]
      }

      // 遍历原始数据
      for (let j = 0; j < len; j++) {
        const list = data[j]
        // 通过每条数据的 pid 去obj中查询
        const parentList = obj[list['FParentID']]

        if (parentList) {
          // 根据 pid 找到的是父节点，list是子节点，
          if (!parentList['children']) {
            parentList['children'] = []
          }
          // 将子节点插入 父节点的 children 字段中
          parentList['children'].push(list)
        } else {
          // pid 找不到对应值，说明是根结点，直接插到根数组中
          res.push(list)
        }
      }
      this.datasele = res
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleSelectionChange(val) {
      const dataId = []
      // if (val.length > 1) {
      val.map((item) => {
        dataId.push(item.FID)
      })
      this.dataStr = dataId.join(',')
      // }else {}
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getInitData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getInitData()
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  list-style-type: none;
}
.app-container {
  background: #ffffff;
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .iconBox {
    width: 35px;
    height: 35px;
  }
  .commodity-form {
    display: flex;
    margin: 10px 10px;
    .first-button {
      background-color: #ec212d;
      color: #fff;
      margin: 0 62px 0 10px;
    }
  }
  .search-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #ec212d;
    .title-text {
      color: #fff;
      font-size: 20px;
      margin-left: 31px;
    }
  }
  .top-search {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .form-button {
    // width: 175px;
    height: 24px;
    font-size: 12px;
    line-height: 0;
    color: #ec212d;
    background: #fff;
    border: 1px solid #ec212d;
    border-radius: 4px;
    padding: 0 10px;
  }
  .bigBox {
    margin-top: 15px;
    .left-condition {
      float: left;
      width: 230px;
      height: 677px;
      background: #f1f1f1;
      .condition-conton {
        width: 100%;
        .con-header {
          margin: 9px 14px 0px 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .search-top {
              height: 18px;
              display: flex;
              justify-content: center;
              align-items: center;
          }
          .branch {
            display: inline-block;
            height: 18px;
            border-right: 3px solid #ec212d;
          }
          .query {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-left: 8px;
          }
          .right {
            width: 6px;
            color: #ec212d;
          }
        }
        .con-con {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          margin: 11px 10px 6px 0px;
          .confirm {
            display: inline-block;
          }
          .con-select {
            display: inline-block;
            width: 122px;
            height: 24px;
            background: #ffffff;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
          }
          .condition {
            margin: 6px 10px 0px 8px;
          }
        }
      }
    }
    .right-table {
      // height: 100%;
      padding: 0 24px;
      overflow: hidden;
      // float: left;
      position: relative;
      .commodity-pagination {
        text-align: center;
        margin-top: 10px;
      }
      .right-operation {
          width: 100%;
          margin-top: 15px;
          margin-bottom: 10px;
          .search-form {
              display: inline-block;
          }
          .el-button {
              display: inline-block;
              position: relative;
            //   span {
            //       position: absolute;
            //       top: 50%;
            //       left: 50%;
            //       transform: translate(-50%,-50%);
            //   }
              i {
                  margin-top: -2px;
                  margin-left: -5px;
              }
          }
          .left-btn {
            width: 133px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px;
            opacity: 1;
            border: 1px solid #EC212D;
            font-size: 16px;
            color: #EC212D;
          }
          .right-btn {
            width: 93px;
            height: 40px;
            background: #EC212D;
            border-radius: 4px;
            opacity: 1;
            font-size: 16px;
            color: #fff;
          }
      }
    }
  }
  .bottom-table {
    // height: 500px;
    height: 88%;
    .bottom-operation {
            display: flex;
            color: #EC212D;
            span {
                display: inline-block;
                width: 62px;
                cursor: pointer;
                text-align: center;
            }
            span:nth-child(2) {
                border-left: 1px solid #CECFD9;
                border-right: 1px solid #CECFD9;
            }
        }
  }
  .operation-icon {
    width: 16px;
    height: 16px;
    margin-right: 15px;
    cursor: pointer;
  }
  .one-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

}

</style>
<style lang="scss">
.commodity-form {
  .el-input__suffix {
    right: 10px;
  }
}
.commodity-form {
  .el-form-item__content {
    margin-right: 20px;
  }
}
// .el-select-dropdown__item.selected {
//   color: #1b7469 !important;
// }
.right-table {
    .el-table__body-wrapper {
        height: 526px !important;
        overflow-y: auto;
    }
  .bottom-table .el-table {
    // height: 60vh;
    overflow-y: auto;
  }
  th {
    padding: 5px;
  }
  td {
    // font-size: 12px;
    padding: 5px;
    color: #202020;
  }
  .el-pagination.is-background .el-pager li {
    background: none;
    border: 1px solid #ccc;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ec212d;
  }
}

.refuse-view {
  .el-dialog {
    min-height: 470px;
    overflow: hidden;
    overflow-y: scroll;
    min-width: 800px;
  }
  .el-dialog__header {
    background-color: #2db0a0;
  }
  .el-dialog__title,
  .el-dialog__close {
    color: #ffffff;
  }
  .refuse-title {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .refuse-content {
    width: 100%;
    height: 78px;
    background: #f5f5f5;
    border: 1px solid #d2d2d2;
    box-sizing: border-box;
    padding: 10px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
  .refuse-content-image {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0 20px 0;
    img {
      width: 178px;
      height: 240px;
      border: 1px dashed #dcdcdc;
    }
  }
  .refuse-close {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .refuse-close-btn {
      width: 135px;
      height: 30px;
      border: 1px solid #34bcb0;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #2db0a0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
// .el-select .el-input__icon {
//   line-height: 24px !important;
// }
.condition .el-input__inner {
  height: 36px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.condition .el-tree {
  width: 100%;
  max-height: 585px;
  background: #f1f1f1;
  overflow-y: auto;
  margin-top: 8px;
  // overflow-x: auto;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  .el-tree-node__label {
    font-size: 14px;
  }
}
#appid .el-tree-node__content {
  height: 29px;
}
#appid .el-pagination {
  text-align: right;
  margin-top: 15px;
}
.filter-tree .el-tree-node > .el-tree-node__children{
    overflow: unset;
  }
</style>
